import { Globe2, ChevronDown } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { LOCALES, LOCALE_LABELS, localizedPath, type Locale } from "@shared/i18n";

export function LanguageSwitcher() {
  const { locale, fullPath } = useLanguage();
  const labels = { en: "Choose language", de: "Sprache wählen", tr: "Dil seçin" };
  return <div className="relative flex h-9 shrink-0 items-center border border-black/20 bg-transparent text-[#171717]">
    <Globe2 aria-hidden="true" className="pointer-events-none absolute left-2 h-3.5 w-3.5" />
    <select aria-label={labels[locale]} value={locale} onChange={event => {
      const destination = localizedPath(fullPath + window.location.hash, event.target.value as Locale);
      window.location.assign(destination);
    }} className="h-full w-[104px] cursor-pointer appearance-none bg-transparent pl-7 pr-5 text-[10px] font-bold tracking-wider outline-offset-4 focus-visible:outline-2 focus-visible:outline-black">
      {LOCALES.map(code => <option key={code} value={code} lang={code}>{LOCALE_LABELS[code]}</option>)}
    </select>
    <ChevronDown aria-hidden="true" className="pointer-events-none absolute right-1.5 h-3 w-3" />
  </div>;
}
